





































import { Component, Vue } from 'vue-property-decorator';
import SectionTuileNav from '@/components/shared/SectionTuileAnimNav.vue'
import SectionTuileDouble from '@/components/shared/SectionTuileDouble.vue'
import { ITuileNav } from '@/models/ui/ITuileNav';
import { ADomicileAdulte} from '@/router/pages';
import { ConvertToTuileNav } from '@/models/alo/AloActivity';

@Component({
  name:"Adultes",
  components: { SectionTuileNav,SectionTuileDouble},
})
export default class Adultes extends Vue {
  private arianeItems = [
        {
          text: 'Accueil',
          disabled: false,
          to: {name:'Home'},    
          exact:true      
        },
        {
          text: 'Activités adultes',
          disabled: true
        }
      ]


  get coursItems(){
    return this.$store.myGetters.activityList.filter(a => !a.acyEnfant).map(a => ConvertToTuileNav(a))        
  }

  created(){        
    this.$store.myActions.ADM_ACTIVITY_ENSURE()
  }

  private domicileItems = [
    /*EnVisio,*/    
    ADomicileAdulte
    /*ADomicileNatationAdulte,
    ADomicileAquafitnsessAdulte*/
  ]
}
